import { styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  color: theme.palette.common.white,
  padding: '2rem 1rem',
  flexGrow: 1,
  gap: '2rem',
  background: theme.palette.primary.dark,
  border: `1px solid ${theme.palette.secondary.dark}`,
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
  justifyContent: 'center',
  alignItems: 'center',
  flexGrow: 1,
  textAlign: 'center',
}));
export const SearchmgStyled = styled('img')(() => ({
  width: '10.5rem',
  marginTop: '1.5rem',
}));

export const TextWarning = styled('div')(() => ({
  maxWidth: '26rem',
}));
